export type { TeacherDetailPageData } from "~/utils/page-data/builders/teacher-detail";
export { buildTeacherDetailPageData } from "~/utils/page-data/builders/teacher-detail";

import type { TeacherDetailPageData } from "~/utils/page-data/builders/teacher-detail";
import { fetchPageBff } from "~/utils/page-data/client-fetch";

export async function fetchTeacherDetailPageData(
	teacherId: string | number,
	locale = "zh-TW"
): Promise<TeacherDetailPageData> {
	try {
		return await fetchPageBff<TeacherDetailPageData>(
			`/seer/api/page/teacher-detail/${teacherId}`,
			undefined,
			{ locale }
		);
	} catch (error) {
		console.error("Failed to load teacher detail page data", error);
		return {
			teacherInfo: {},
			consultService: [],
			fahuiService: [],
			mediaContent: {
				horizVideo: [],
				vertVideo: [],
				articleList: [],
			},
		};
	}
}
